import React, { useEffect, useReducer } from 'react'

import get from 'lodash/get'
import isEqual from 'lodash/isEqual'

import { useQuery } from '../hooks/useQuery'
import usePrevious from '../../hooks/common/usePrevious'

function reducer(state, newState) {
  return {
    ...state,
    ...newState,
  }
}

const initialState = {
  page: 1,
  feeds: [],
  feedsInlastBatch: 0,
  variables: {},
}

const withFeed = BaseComponent => props => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const operation = 'feeds'
  const insToken = get(props, 'currentUser.insToken')
  const defaultVariables = {
    insToken: { value: insToken, type: 'String', required: true },
    onlyInterestsSearch: { value: false, type: 'Boolean', required: true },
    page: { value: 1, type: 'Int', required: true },
    searchTerm: { value: [], required: true, list: true, name: 'searchTerm' },
  }

  const { data, refetch, loading, error } = useQuery(operation, defaultVariables, {
    lazy: true,
  })

  const previousData = usePrevious(data)
  useEffect(() => {
    if (!!data && (!state.feeds.length || !isEqual(previousData, data))) {
      dispatch({ feeds: state.feeds.concat(data), feedsInLastBatch: data.length })
    }
  }, [data, previousData])

  const getFeedsData = variables => {
    if (isEqual(variables, state.variables)) {
      return
    }

    const { page } = variables
    dispatch({ page, variables })
    if (page === 1) {
      dispatch({ feeds: [] })
    }

    refetch(variables)
  }

  const isNoFeeds = !loading && !!data && !state.feeds.length

  return (
    <BaseComponent
      {...props}
      feedsError={error}
      feedsData={state.feeds}
      getFeedsData={getFeedsData}
      loadingFeeds={loading}
      loadMoreDataLength={state.feeds.length}
      isNoLoadMoreData={state.feedsInLastBatch === 0}
      page={state.page}
      isNoFeeds={isNoFeeds}
    />
  )
}

export default withFeed



// WEBPACK FOOTER //
// ./src/utils/graphql/hocs/withFeed.js